var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 40,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.9034 11.28L14.5226 33.6362L3.0127 22.1821L4.39206 20.796L14.5499 30.9046L36.5519 9.8667L37.9034 11.28Z",
  fill: "#009877"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 22.2128L8.00001 17.6346L14.5873 24.7614L33.5555 6.36377L38 11.222L14.5079 33.6018L3 22.2128Z",
  stroke: "#06262D",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgCheckIcon as ReactComponent };
export default __webpack_public_path__ + "images/checkIcon.svg";